/* eslint-disable import/no-anonymous-default-export */
import { TransactionShow } from './TransactionShow';
import { TransactionList } from './TransactionList';
import { Transaction } from '../../types/types';

export default {
    list: TransactionList,
    show: TransactionShow,
    recordRepresentation: (record: Transaction) => record.transaction_id,
};
